import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: frankgrinaert
 * id 237B205E-C03C-424A-93F9-8C771FE01A38
 * name archive-arrow-down
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-down.svg
 * tags
 */
export const ArchiveArrowDownIcon = createSvgIcon(<><path d="M3 3H21V7H3V3M4 21V8H20V21H4M14 14V11H10V14H7L12 19L17 14H14Z" /></>, 'ArchiveArrowDownIcon');
export default ArchiveArrowDownIcon